import wrapWithProvider from './wrap-with-provider';
import initRecurlyJs from './recurly';
import CustomLayout from './wrap-page-element';

export const wrapRootElement = wrapWithProvider;
export const wrapPageElement = CustomLayout;

initRecurlyJs();
